export default __webpack_public_path__ + "static/media/clientwhatsapp.cf340ecf.svg";